import React from 'react';
import EnterpriseTool from './forms/enterpriseTool/EnterpriseTool';
import RepairReplaceGraphScreen from './forms/repairReplace/repairReplace';

function FormRouter({ formType, ...props }) {
  let apiFormType = formType;

  switch (formType) {
    case 'diagnostic':
    case 'pricing':
    case 'prevMaintenance':
    case 'emergency':
      return <EnterpriseTool {...props} formType={apiFormType} />;
    case 'repairReplace':
      return <RepairReplaceGraphScreen {...props} />;
    default:
      return <div>Form not found.</div>;
  }
}
export default FormRouter;
